import i18n from "../i18n";

export const getCurrentLanguage = () =>
  i18n.language || window.localStorage.i18nextLng;

export const changeLanguageHandler = (lang: 'pt-BR' | 'en-US' ) => {
  i18n.changeLanguage(lang);
};
